export const renderHtml = trans => {
    return { __html: trans };
}